import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import NotificationCard from "../../Components/Notification/NotificationCard/index";
import { connect } from "react-redux";
import axios from "axios";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Notificaations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notification_data: [],
      loading: true,
      fakeData: [1, 2, 3, 4],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Notification";
    this.fetchNotification({
      student_class: this.props.user.student_class.id,
      section: this.props.user.student_section.id,
    });
  }

  fetchNotification = (params = {}) => {
    axios
      .get("/mApiV1/StudentNoticeList", { params: { ...params } })
      .then((res) => {
        this.setState({ notification_data: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header to="/home" title="Notification" />
        <div className="container pt-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton width={150} />
                    <Skeleton count={2} />
                  </div>
                );
              })
            : null}
          {this.state.notification_data.length !== 0 &&
          this.state.loading === false
            ? this.state.notification_data?.map((item, index) => {
                return (
                  <div className="my-3" key={index}>
                    <NotificationCard
                      date={item.from_date}
                      message={item.message}
                    />
                  </div>
                );
              })
            : null}

          {this.state.notification_data.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Notifications!
              </p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Notificaations);
